export default __webpack_public_path__ + "static/media/logo-white.57d2355b.png";